import React from "react";
import ErrorBoundaryFactory from "./ErrorBoundaryFactory";

function getDisplayName(WrappedComponent) {
  return WrappedComponent.displayName || WrappedComponent.name || 'Component';
}

export const withErrorBoundary = (WrappedComponent, ErrorBoundary) => {
  class WithErrorBoundary extends ErrorBoundaryFactory {
    render() {
      if (this.state.hasError) {
        return <ErrorBoundary {...this.state}/>
      }
      return <WrappedComponent {...this.props}/>
    }
  }

  WithErrorBoundary.displayName = `${getDisplayName(WrappedComponent)}`;

  return WithErrorBoundary;
}